import styled from "styled-components";

import InputLabel from "@material-ui/core/InputLabel";

export const StyledInputLabel = styled(InputLabel)`
  && {
    .req-label {
      color: #f44336;
    }
    /* font-size: 14px; */
  }
`;
